export default "__VITE_ASSET__DAcchig2__"